import { DndContext, closestCenter, PointerSensor, useSensor, useSensors } from '@dnd-kit/core';
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';

const DraggableList = ({ microtaskFields, renderMicrotask, move }) => {
    const sensors = useSensors(
        useSensor(PointerSensor, {
            activationConstraint: { distance: 5 },
        })
    );

    const handleDragEnd = (event) => {
        const { active, over } = event;
        if (!over || active.id === over.id) return;

        const oldIndex = microtaskFields.findIndex((item) => item.id === active.id);
        const newIndex = microtaskFields.findIndex((item) => item.id === over.id);

        if (oldIndex === -1 || newIndex === -1) return;

        // ✅ ONLY move via useFieldArray
        move(oldIndex, newIndex);
    };

    return (
        <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
            <SortableContext items={microtaskFields.map((item) => item.id)} strategy={verticalListSortingStrategy}>
                {microtaskFields.map(renderMicrotask)}
            </SortableContext>
        </DndContext>
    );
};

export default DraggableList;
